import { MDBInput } from 'mdb-react-ui-kit'
import React, { useEffect, useState } from 'react'
import personal from '../../Assets/Images/personalInfoNew.jpg'
import { setDefaultLocale } from 'react-datepicker';

function PersonalDetailsBike({ formData, setFormData, setPersonalInfoError }) {
    const [errors, setErrors] = useState({
        email: '',
        pincode: '',
        mobile: '',
    });

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const pincodeRegex = /^\d{6}$/;
    const mobileRegex = /^\d{10}$/;


    function handleInputChange(event) {
        const { name, value } = event.target;

        // Update form data
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));

        // Validate email if the input name is 'email'
        if (name === 'email') {
            const isValidEmail = emailRegex.test(value);
            setErrors(prevErrors => ({
                ...prevErrors,
                email: isValidEmail ? '' : 'Email is not valid'
            }));
            setPersonalInfoError(!isValidEmail); // Update personalInfoError based on email validity
        }
        if (name === 'pincode') {
            const isValidPincode = pincodeRegex.test(value);
            setErrors(prevErrors => ({
                ...prevErrors,
                pincode: isValidPincode ? '' : 'Pincode is not valid'
            }));
            setPersonalInfoError(!isValidPincode); // Update personalInfoError based on pincode validity
        }
        if (name === 'number') {
            const isValidMobile = mobileRegex.test(value);
            setErrors(prevErrors => ({
                ...prevErrors,
                mobile: isValidMobile ? '' : 'Mobile number is not valid'
            }));
            setPersonalInfoError(!isValidMobile); // Update personalInfoError based on mobile number validity
        }
    }
    return (
        <div className='container'>
            <div className='row my-5'>
                <div className=' input-feilds-personal '>
                    <div>
                        <MDBInput
                            value={formData.name}
                            onChange={handleInputChange}
                            name='name'
                            label='Name'
                            id='name'
                            type='text'
                            autoComplete='off'
                        />
                    </div>
                    <div className='mt-3'>
                        <MDBInput
                            value={formData.email}
                            onChange={handleInputChange}
                            name='email'
                            label='Email'
                            id='email'
                            type='email'
                            error={errors.email}
                            autoComplete='off'
                        />
                        {errors.email && (<div className='text-danger'>{errors.email}</div>)}
                    </div>
                    <div className='mt-3'>
                        <MDBInput
                            value={formData.number}
                            onChange={handleInputChange}
                            name='number'
                            label='Mobile Number'
                            id='number'
                            type='text'
                            autoComplete='off'
                        />
                        {errors.mobile && (<div className='text-danger'>{errors.mobile}</div>)}
                    </div>
                    <div className='mt-3'>
                        <MDBInput
                            value={formData.pincode}
                            onChange={handleInputChange}
                            name='pincode'
                            label='Pincode'
                            id='pincode'
                            autoComplete='off'
                            type='text'
                        />
                        {errors.pincode && (<div className='text-danger'>{errors.pincode}</div>)}
                    </div>
                </div>
                {/* <div className='col-md-7 d-flex justify-content-center'>
                    <div className='personal-info-image'>
                        <img src={personal} className='family-image' alt='Family' />
                    </div>
                </div> */}
            </div>
        </div>
    );
}

export default PersonalDetailsBike;
